uniform vec2 uResolution;
uniform float uSize;
uniform float uProgress;
uniform vec3 uColorA;
uniform vec3 uColorB;
uniform float uTime;

attribute vec3 aPositionTarget;
attribute float aSize;

#include ../includes/simplexNoise3d.glsl

varying vec3 vColor;
varying float vAlpha;
varying float vSize;

void main()
{
    // Mixed position
    float noiseOrigin = simplexNoise3d(position * 0.2);
    float noiseTarget = simplexNoise3d(aPositionTarget * 0.2);
    float noise = mix(noiseOrigin, noiseTarget, uProgress);
    noise = smoothstep(-1.0, 1.0, noise);

    float duration = 0.4;
    float delay = (1.0 - duration) * noise;
    float end = delay + duration;
    float progress = smoothstep(delay, end, uProgress);
    vec3 mixedPosition = mix(position, aPositionTarget, progress);

    // Subtle floating motion
    float floatOffset = sin(uTime * 0.5 + noise * 6.28) * 0.02;
    mixedPosition.y += floatOffset;

    // Final position
    vec4 modelPosition = modelMatrix * vec4(mixedPosition, 1.0);
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;

    // Dynamic size with subtle pulsing
    float pulse = 1.0 + sin(uTime * 2.0 + noise * 6.28) * 0.15;
    float baseSize = aSize * uSize * uResolution.y * pulse;
    gl_PointSize = baseSize;
    gl_PointSize *= (1.0 / - viewPosition.z);

    // Color mixing with brightness variation
    float colorMix = noise;
    vColor = mix(uColorA, uColorB, colorMix);

    // Brighter particles in the center, softer at edges
    float brightness = 0.7 + aSize * 0.5;
    vColor *= brightness;

    // Alpha variation based on size and depth
    vAlpha = 0.6 + aSize * 0.4;
    vSize = aSize;
}
